<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row d-flex justify-content-center">
                <div class="col-md-2">
                  <label>Data inicial</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="filtro.data_inicio"
                  />
                </div>
                <div class="col-md-2">
                  <label>Data final</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="filtro.data_fim"
                  />
                </div>
                <div class="col-md-2">
                  <label>Rota</label>
                  <v-select
                    v-model="filtro.rota"
                    class="vselect"
                    :options="rotas"
                    :reduce="(rotas) => rotas.id"
                    :label="'nome'"
                    multiple
                    @input="changeFiltro"
                  />
                </div>
                <div class="col-md-2">
                  <label>Tipo de veículo</label>
                  <v-select
                    v-model="filtro.tipo_veiculo"
                    class="vselect"
                    :options="tipo_veiculos"
                    :reduce="(tipo_veiculos) => tipo_veiculos.id"
                    :label="'nome'"
                    multiple
                    @input="changeFiltro"
                  />
                </div>
                <div class="col-md-2">
                  <label>Veículo</label>
                  <v-select
                    v-model="filtro.equipe_id"
                    class="vselect"
                    :options="veiculos"
                    :reduce="(veiculos) => veiculos.veiculo_samu_id"
                    :label="'nome'"
                    multiple
                  />
                </div>
                <div class="col-md-2">
                  <br />
                  <button
                    class="btn btn-primary"
                    @click="getPedidos"
                    :disabled="
                      filtro.data_inicio && filtro.data_fim ? false : true
                    "
                  >
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="col-12 mt-1" v-if="pedidos.resumo.length > 0">
                <!-- Alert para seleção múltipla -->
                <div
                  class="alert alert-warning"
                  role="alert"
                  v-if="selecaoMultipla"
                >
                  <strong>Atenção!</strong> Para gerar requisição ou adicionar
                  um material é preciso buscar apenas por
                  <strong>Uma rota</strong>,
                  <strong>Um tipo de veículo</strong> e
                  <strong>Um veículo</strong>.
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Material</th>
                          <th scope="col">Requisição</th>
                          <th scope="col">Reposição</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(material, index) in pedidos.resumo"
                          :key="index"
                        >
                          <th scope="row">{{ index + 1 }}</th>
                          <td
                            :style="
                              material.controlado == 'S'
                                ? 'color: red; font-weight: bold'
                                : ''
                            "
                          >
                            {{ material.medicacao_descricao }}
                            <span
                              class="badge badge-danger"
                              v-if="material.solicitado_manual"
                              >Solicitado Manualmente</span
                            >
                          </td>
                          <td>{{ material.quantidade_total }}</td>
                          <td>0</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 mt-3">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-toggle="modal"
                      data-target="#modalAddMaterial"
                      :disabled="!selecaoUnica"
                      :title="
                        !selecaoUnica
                          ? 'Selecione apenas uma rota, um tipo de veículo e um veículo'
                          : ''
                      "
                    >
                      Adicionar Material
                    </button>
                    <button
                      type="button"
                      class="ml-2 btn btn-primary"
                      @click="gerarPedido(pedidos)"
                      :disabled="!selecaoUnica"
                      :title="
                        !selecaoUnica
                          ? 'Selecione apenas uma rota, um tipo de veículo e um veículo'
                          : ''
                      "
                    >
                      Gerar Requisição
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-12 centered" v-else>
                Selecione um veículo para visualizar o consumo
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modalAddMaterial"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalAddMaterialTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Incluir Material
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-10">
                <label>Selecione um material</label>
                <v-select
                  v-model="new_material.obj"
                  class="vselect"
                  :options="materiais"
                  :reduce="(materiais) => materiais"
                  :label="'nome'"
                />
              </div>
              <div class="col-md-2">
                <label>Quantidade</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="new_material.qtd"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="incluirProduto"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      filtro: {
        data_inicio: this.getDateOneWeekAgo(),
        data_fim: this.getTodayDate(),
        rota: [],
        tipo_veiculo: [],
        equipe_id: [],
      },
      pedidos: {
        resumo: [],
      },
      rotas: [],
      tipo_veiculos: [],
      veiculos: [],
      materiais: [],
      new_material: {},
    };
  },
  computed: {
    selecaoUnica() {
      const rotaUnica =
        Array.isArray(this.filtro.rota) && this.filtro.rota.length === 1;
      const tipoVeiculoUnico =
        Array.isArray(this.filtro.tipo_veiculo) &&
        this.filtro.tipo_veiculo.length === 1;
      const equipeUnica =
        Array.isArray(this.filtro.equipe_id) &&
        this.filtro.equipe_id.length === 1;

      return rotaUnica && tipoVeiculoUnico && equipeUnica;
    },
    selecaoMultipla() {
      const rotaMultipla =
        Array.isArray(this.filtro.rota) && this.filtro.rota.length > 1;
      const tipoVeiculoMultiplo =
        Array.isArray(this.filtro.tipo_veiculo) &&
        this.filtro.tipo_veiculo.length > 1;
      const equipeMultipla =
        Array.isArray(this.filtro.equipe_id) &&
        this.filtro.equipe_id.length > 1;

      return rotaMultipla || tipoVeiculoMultiplo || equipeMultipla;
    },
  },
  methods: {
    incluirProduto() {
      const self = this;

      var obj = {
        id_material: self.new_material.obj.id,
        medicacao_descricao: self.new_material.obj.nome,
        quantidade_total: self.new_material.qtd,
        controlado: self.new_material.obj.portaria ? "S" : "N",
        solicitado_manual: 1,
      };

      self.pedidos.resumo.push(obj);

      self.new_material = {};

      $("#modalAddMaterial").modal("hide");
    },
    changeFiltro: function () {
      const self = this;

      self.veiculos = [];

      if (
        (Array.isArray(self.filtro.rota) && self.filtro.rota.length > 0) ||
        (Array.isArray(self.filtro.tipo_veiculo) &&
          self.filtro.tipo_veiculo.length > 0)
      ) {
        let api = self.$store.state.api + "filtro_veiculos?";

        self.$loading(true);

        // Enviar múltiplas rotas
        if (Array.isArray(self.filtro.rota) && self.filtro.rota.length > 0) {
          self.filtro.rota.forEach((rota) => {
            api += "&rota[]=" + rota;
          });
        }

        // Enviar múltiplos tipos de veículo
        if (
          Array.isArray(self.filtro.tipo_veiculo) &&
          self.filtro.tipo_veiculo.length > 0
        ) {
          self.filtro.tipo_veiculo.forEach((tipo) => {
            api += "&tipo_veiculo[]=" + tipo;
          });
        }

        axios
          .get(api)
          .then((response) => {
            self.veiculos = response.data;

            self.$loading(false);
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      } else {
        self.getVeiculos();
      }
      self.filtroArray();
    },
    filtroArray: function () {
      const self = this;

      // Se não tiver rotas selecionadas, limpa o array
      if (!Array.isArray(self.filtro.rota) || self.filtro.rota.length === 0) {
        self.filtro.arrayRota = [];
        return;
      }

      let allVeiculos = [];
      let promises = [];

      // Buscar veículos de cada rota selecionada
      self.filtro.rota.forEach((rotaId) => {
        const api =
          self.$store.state.api +
          "rota_veiculos?paginated=false&rota_id=" +
          rotaId;

        promises.push(
          axios.get(api).then((response) => {
            response.data.data.forEach((veiculo) => {
              if (!allVeiculos.includes(veiculo.equipe_id)) {
                allVeiculos.push(veiculo.equipe_id);
              }
            });
          })
        );
      });

      // Esperar todas as requisições terminarem
      Promise.all(promises)
        .then(() => {
          self.filtro.arrayRota = allVeiculos;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRotas: function () {
      const self = this;
      const api = self.$store.state.api + "rotas?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.rotas = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTipoVeiculo: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_veiculos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.tipo_veiculos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getVeiculos: function () {
      const self = this;
      const api = self.$store.state.api + "veiculos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.veiculos = response.data.data;
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getMateriais: function () {
      const self = this;
      const api = self.$store.state.api + "materiais?paginated=false";
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.materiais = response.data.data;
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPedidos: function () {
      const self = this;
      const api =
        self.$store.state.url_semanal +
        "api/consulta/consumo-medicamentos/" +
        self.$store.state.database;

      self.$loading(true);

      // Criar lista de equipes a serem consultadas
      const equipesParaConsultar =
        Array.isArray(self.filtro.equipe_id) && self.filtro.equipe_id.length > 0
          ? self.filtro.equipe_id
          : [null];

      // Preparar informações dos tipos de veículo
      const tiposVeiculoInfo = {};
      if (Array.isArray(self.filtro.tipo_veiculo)) {
        self.tipo_veiculos.forEach((tipo) => {
          if (self.filtro.tipo_veiculo.includes(tipo.id)) {
            tiposVeiculoInfo[tipo.id] = tipo.nome;
          }
        });
      }

      // Criar promises para cada equipe
      const promises = equipesParaConsultar.map((equipeId) => {
        const dadosEnvio = {
          data_inicio: self.filtro.data_inicio,
          data_fim: self.filtro.data_fim,
          rota:
            Array.isArray(self.filtro.rota) && self.filtro.rota.length > 0
              ? self.filtro.rota[0]
              : null,
          tipo_veiculo:
            Array.isArray(self.filtro.tipo_veiculo) &&
            self.filtro.tipo_veiculo.length > 0
              ? self.filtro.tipo_veiculo[0]
              : null,
          equipe_id: equipeId,
          arrayRota: self.filtro.arrayRota || [],
          tipo_veiculo_nome:
            tiposVeiculoInfo[self.filtro.tipo_veiculo[0]] || "",
        };

        console.log(`Consultando equipe ${equipeId}:`, dadosEnvio);

        return axios
          .post(api, dadosEnvio)
          .then((response) => response.data)
          .catch((error) => {
            console.error(`Erro ao consultar equipe ${equipeId}:`, error);
            return null;
          });
      });

      // Aguardar todas as requisições
      Promise.all(promises)
        .then((resultados) => {
          // Filtrar resultados válidos
          const resultadosValidos = resultados.filter((r) => r !== null);

          if (resultadosValidos.length === 0) {
            self.$message(null, "Nenhum resultado encontrado", "warning");
            self.pedidos = { resumo: [] };
            self.$loading(false);
            return;
          }

          // Combinar os resumos de todos os resultados
          const resumoCombinado = {};

          resultadosValidos.forEach((resultado) => {
            if (resultado.resumo && Array.isArray(resultado.resumo)) {
              resultado.resumo.forEach((material) => {
                const key =
                  material.id_material || material.medicacao_descricao;

                if (resumoCombinado[key]) {
                  // Material já existe, somar quantidades
                  resumoCombinado[key].quantidade_total +=
                    material.quantidade_total || 0;
                } else {
                  // Novo material, adicionar ao resumo
                  resumoCombinado[key] = { ...material };
                }
              });
            }
          });

          // Converter objeto de volta para array
          const resumoFinal = Object.values(resumoCombinado);

          // Ordenar por descrição
          resumoFinal.sort((a, b) =>
            (a.medicacao_descricao || "").localeCompare(
              b.medicacao_descricao || ""
            )
          );

          self.pedidos = {
            resumo: resumoFinal,
            total_requisicoes: resumoFinal.reduce(
              (sum, m) => sum + (m.quantidade_total || 0),
              0
            ),
          };

          console.log(
            `Total de ${equipesParaConsultar.length} equipes consultadas`
          );
          console.log(`${resumoFinal.length} materiais diferentes encontrados`);

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          console.error("Erro ao processar resultados:", error);
          self.$message(null, "Erro ao processar resultados", "error");
        });
    },
    getDateOneWeekAgo() {
      const date = new Date();
      date.setDate(date.getDate() - 7);
      return date.toISOString().split("T")[0];
    },
    getTodayDate() {
      const date = new Date();
      return date.toISOString().split("T")[0];
    },
    gerarPedido: function () {
      const self = this;
      let api = self.$store.state.api + "pedido/semanal";

      let pedido = {
        resumo: self.pedidos.resumo,
        pedido: self.filtro,
      };

      self.$loading(true);

      axios
        .post(api, pedido)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/pedidos");
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    createUnidade: function (veiculo) {
      const self = this;
      const api = self.$store.state.api + "unidades";

      let data = {
        nome: veiculo,
        sigla: veiculo,
        cnes: 0,
        cep: "00000-000",
        logradouro: "Não disponível",
        bairro: "Não disponível",
        numero: 0,
        cidade: "Não disponível",
        estado: "ND",
        pais: "Brasil",
      };

      axios
        .post(api, data)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getRotas();
    self.getTipoVeiculo();
    self.getVeiculos();
    self.getMateriais();
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
.badge-orange {
  background: #d34300;
  color: white;
}
.badge-purple {
  background: #880088;
  color: white;
}
</style>
